const maps = $('.map-block__map-col');

if (maps.length) {
	$(window).on('load', function () {
		maps.each(function () {
			const mapStory = $(this).find('.map-block__netwerken-terms');
			appendBlockOnMapLoad($(this), mapStory);
		});
	});
}

function appendBlockOnMapLoad(mapWrap, story) {
	const map = mapWrap.find('.mapsvg-wrap');

	if (!map.length) {
		setTimeout(appendBlockOnMapLoad, 1000, mapWrap, story);
	} else {
		map.append(story);
	}
}



// WEBPACK FOOTER //
// ./scripts/autoload/_mapsvg-map-story.js